import React, { useEffect, useRef } from 'react';
import * as d3 from 'd3';

const Tooltip = ({ content, position, hovered }) => {
    const tooltipRef = useRef(null);

    useEffect(() => {
        const tooltip = d3.select(tooltipRef.current);

        tooltip
            .style('left', '-9999px')
            .style('top', '-9999px')
            .style('display', 'block')
            .style('min-width', '80px');
        
        const adjustPosition = (pos) => {
            if (!pos || !tooltipRef.current) return { x: 0, y: 0 };

            const tooltipNode = tooltipRef.current;
            const { width: tooltipWidth, height: tooltipHeight } = tooltipNode.getBoundingClientRect();
            
            // Get the viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            // Convert page coordinates to viewport-relative coordinates
            const rect = tooltipNode.getBoundingClientRect();
            const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // Calculate initial position relative to viewport
            let x = pos.x - scrollLeft;
            let y = pos.y - scrollTop;

            // Add offset for tooltip
            const offset = 10;
            x += offset;
            y -= offset;

            // Adjust if tooltip would go outside viewport
            if (x + tooltipWidth > viewportWidth) {
                x = x - tooltipWidth - offset * 2;
            }

            if (y + tooltipHeight > viewportHeight) {
                y = y - tooltipHeight - offset;
            }

            // Ensure tooltip doesn't go outside left or top edges
            x = Math.max(0, x);
            y = Math.max(0, y);

            // Convert back to page coordinates
            return {
                x: x + scrollLeft,
                y: y + scrollTop
            };
        };

        const adjustedPosition = adjustPosition(position);
        
        if (content) {
            tooltip
                .style('display', 'block')
                .html(content)
                .style('left', `${adjustedPosition.x}px`)
                .style('top', `${adjustedPosition.y}px`);
        } else {
            tooltip.style('display', 'none');
        }

        if (hovered) {
            const element = d3.select(hovered);
            const parentNode = element.node() && element.node().parentNode;

            if (parentNode) {
                const parentGroup = d3.select(parentNode);
                const grandParentNode = parentGroup.node().parentNode;
                
                if (grandParentNode) {
                    grandParentNode.appendChild(parentGroup.node());
                }

                element
                    .attr('original-stroke', element.style('stroke'))
                    .attr('original-stroke-width', element.style('stroke-width'));

                element
                    .style('stroke', 'white')
                    .style('stroke-opacity', '0.8')
                    .style('stroke-width', '2px');
            }
        }

        return () => {
            if (hovered) {
                const element = d3.select(hovered);
                if (element.node()) {
                    element
                        .style('stroke', element.attr('original-stroke'))
                        .style('stroke-width', element.attr('original-stroke-width'));

                    element
                        .attr('original-stroke', null)
                        .attr('original-stroke-width', null);
                }
            }
        };
        
    }, [content, position, hovered]);

    return (
        <div ref={tooltipRef} className="tooltip" />
    );
};

export default Tooltip;


// import React, { useEffect, useRef } from 'react';
// import * as d3 from 'd3';

// const Tooltip = ({ content, position, hovered }) => {
//     const tooltipRef = useRef(null);
//     // const lastPositionRef = useRef(null);

//     useEffect(() => {
//         const tooltip = d3.select(tooltipRef.current);

//         tooltip
//             .style('left', '-9999px')
//             .style('top', '-9999px')
//             .style('display', 'block')
//             .style('min-width', '80px');
        
//         const adjustPosition = (pos) => {
//             const tooltipNode = tooltip.node();
//             const { width: tooltipWidth } = tooltipNode.getBoundingClientRect();
//             const { innerWidth: windowWidth } = window;

//             let x = pos.x;
//             let y = pos.y;

//             if (x + tooltipWidth > windowWidth ) {
//                 x = windowWidth - tooltipWidth - 10;
//             }

//             return { x, y };
//         };

//         const adjustedPosition = adjustPosition(position);
//         // lastPositionRef.current = adjustedPosition;
        
//         tooltip
//             .style('display', content ? 'block' : 'none')
//             .html(content)
//             .style('left', `${adjustedPosition.x}px`)
//             .style('top', `${adjustedPosition.y}px`);
//             // .style('background-color', 'white');

//         if (hovered) {
//             const element = d3.select(hovered);
//             // const parentGroup = d3.select(element.node().parentNode);
//             const parentNode = element.node() && element.node().parentNode;

//             // // Move the entire group to the top
//             // parentGroup.node().parentNode.appendChild(parentGroup.node());

//             // element
//             //     .attr('original-stroke', element.style('stroke'))
//             //     .attr('original-stroke-width', element.style('stroke-width'));

//             // element
//             //     .style('stroke', 'white')
//             //     .style('stroke-opacity', '0.8')
//             //     .style('stroke-width', '2px');
//             if (parentNode) {
//                 const parentGroup = d3.select(parentNode);

//                 // Move the entire group to the top
//                 if (parentGroup) {
//                     const grandParentNode = parentGroup.node().parentNode;
//                     if (grandParentNode) {
//                         grandParentNode.appendChild(parentGroup.node());
//                     }

//                     element
//                         .attr('original-stroke', element.style('stroke'))
//                         .attr('original-stroke-width', element.style('stroke-width'));

//                     element
//                         .style('stroke', 'white')
//                         .style('stroke-opacity', '0.8')
//                         .style('stroke-width', '2px');
//                 }
//             }
//         }

//         return () => {
//             if (hovered) {
//                 const element = d3.select(hovered);

//                 // Check if the element is still valid
//                 if (element.node()) {
//                     element
//                         .style('stroke', element.attr('original-stroke'))
//                         .style('stroke-width', element.attr('original-stroke-width'));

//                     element
//                         .attr('original-stroke', null)
//                         .attr('original-stroke-width', null);
//                 }
//                 console.log(`hoverd  x=${adjustedPosition.x}, y=${adjustedPosition.y}` );
//             }
//         };
        
//     }, [content, position, hovered]);
//     return (
//         <div ref={tooltipRef} className="tooltip"></div>
//     );
// };

// export default Tooltip;
